const GET_ERROR_LOG = "GET_ERROR_LOG";
const SET_ERROR_LOG = "SET_ERROR_LOG";


export
{
    GET_ERROR_LOG,
    SET_ERROR_LOG    
    
};
